import { ReactElement } from "react";

import { DeleteManyState, TableControls } from "~frontend/components/Table";

import { TAG_SORTS } from "./pagination";

export default function TagListControls({
  sort,
  setSort,
  search,
  setSearch,
  onClickAdd,
  deleteManyState,
  setDeleteManyState,
  onDeleteSelected,
}: {
  sort: string;
  setSort: (newSort: string) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  onClickAdd: () => void;
  deleteManyState: DeleteManyState;
  setDeleteManyState: (newState: DeleteManyState) => void;
  onDeleteSelected: () => void;
}): ReactElement {
  return (
    <TableControls
      addButtons={[{ label: "New Tag", id: "new-tag", onClick: onClickAdd }]}
      sort={{ value: sort, onChange: setSort, options: TAG_SORTS }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for a tag...",
      }}
      deleteMany={{
        deleteManyState,
        setDeleteManyState,
        onDeleteSelected,
        deleteMultipleButtonText: "Delete Tags",
        deleteSelectedButtonText: "Delete Selected Tags",
      }}
    />
  );
}
